import { useEffect } from 'react';
import type { RunningTimer } from '../contexts/TimerContext';
import { elapsedSecondsSince } from '../utils/timer';
import { formatTimerTitle, pickPrimaryTimer } from '../utils/timerTitle';

/** Shows the running timer in the browser tab and restores the original title afterwards. */
export const useTimerDocumentTitle = (running: RunningTimer[]) => {
  const primary = pickPrimaryTimer(running);
  const todoId = primary?.todoId;
  const startedAt = primary?.startedAt;
  const title = primary?.title;

  useEffect(() => {
    if (!todoId || !startedAt || !title) return undefined;
    const original = document.title;
    const update = () => { document.title = formatTimerTitle(elapsedSecondsSince(startedAt), title); };
    update();
    const interval = window.setInterval(update, 1000);
    return () => {
      window.clearInterval(interval);
      document.title = original;
    };
  }, [todoId, startedAt, title]);
};
